import {
  FETCH_LEAVES,
  FETCH_LEAVES_SUCCESS,
  FETCH_LEAVES_FAILURE,
  CREATE_LEAVE,
  CREATE_LEAVE_SUCCESS,
  CREATE_LEAVE_FAILURE,
  UPDATE_LEAVE,
  UPDATE_LEAVE_SUCCESS,
  UPDATE_LEAVE_FAILURE,
  DELETE_LEAVE,
  DELETE_LEAVE_SUCCESS,
  DELETE_LEAVE_FAILURE
} from "./actionTypes";


const initialState = {
  leaves: [],
  loading: false,
  success:false,
  error: null,    
};

const leaveReducer = (state = initialState, action) => {
  switch (action.type) {
   case FETCH_LEAVES:
        return { ...state, loading: true };
      case FETCH_LEAVES_SUCCESS:
        console.log(action.payload.data)
        return { ...state, loading: false, leaves: action.payload.data};
      case FETCH_LEAVES_FAILURE:
        return { ...state, loading: false, error: action.payload };
  
      case CREATE_LEAVE:
        return { ...state, loading: true };
      case CREATE_LEAVE_SUCCESS:
        return {
          ...state, loading: false, success:true, leave: action.payload, error: null };
      case CREATE_LEAVE_FAILURE:
        return { ...state, loading: false, success:false, error: action.payload };
    case UPDATE_LEAVE_SUCCESS:
      return {
        ...state,
        leaves: state.leaves.map(leave => leave.id === action.payload.id ? action.payload : leave)
      };
    case DELETE_LEAVE_SUCCESS:
      return { ...state, leaves: state.leaves.filter(leave => leave.id !== action.payload) };
    default:
      return state;
  }
};

export default leaveReducer;